module.exports = "<iframe [src]=\"embedUrl\" frameborder=\"0\" allowfullscreen></iframe>"